import { useTranslation } from '../i18n';
import React from 'react';
import { Tag } from 'antd';

/**
 * 域名状态标签（共享）
 *
 * 统一 admin / user 两端的域名状态颜色与文案，覆盖完整生命周期
 * （含 grace / redemption / pendingDelete 等）。避免各页面 hand-roll
 * 出现措辞分歧（如 pending 曾被写成「待处理」vs「待激活」）。
 */
export const DOMAIN_STATUS_MAP = {
    pending: { color: 'processing', text: '待激活' },
    registering: { color: 'processing', text: '注册中' },
    processing: { color: 'processing', text: '处理中' },
    failed: { color: 'error', text: '失败' },
    active: { color: 'success', text: '正常' },
    expired: { color: 'error', text: '已过期' },
    suspended: { color: 'warning', text: '已暂停' },
    transferred: { color: 'default', text: '已转出' },
    pendingTransfer: { color: 'blue', text: '转移中' },
    cancelled: { color: 'default', text: '已取消' },
    clientHold: { color: 'red', text: 'Hold' },
    grace: { color: 'orange', text: '宽限期' },
    redemption: { color: 'volcano', text: '赎回期' },
    pendingDelete: { color: 'magenta', text: '待删除' },
    pending_delete: { color: 'magenta', text: '待删除' },
};

/**
 * 状态选项（供筛选下拉复用），保持与 DOMAIN_STATUS_MAP 一致
 */
export const DOMAIN_STATUS_OPTIONS = Object.entries(DOMAIN_STATUS_MAP).map(
    ([value, cfg]) => ({ value, label: cfg.text })
);

const DomainStatusTag = ({ status }) => {
    const { t } = useTranslation();
    const config = DOMAIN_STATUS_MAP[status] || { color: 'default', text: status || '-' };
    return <Tag color={config.color}>{t(config.text)}</Tag>;
};

export default DomainStatusTag;
